module.exports = __webpack_public_path__ + "22d096dde40bd2a567d7bb6f88f3f8c1.svg";